module.exports = __webpack_public_path__ + "img/sp_01.72e2956c.png";